import { render, staticRenderFns } from "./SuperSetup.vue?vue&type=template&id=11c93095&scoped=true"
import script from "./SuperSetup.vue?vue&type=script&lang=js"
export * from "./SuperSetup.vue?vue&type=script&lang=js"
import style0 from "./SuperSetup.vue?vue&type=style&index=0&id=11c93095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c93095",
  null
  
)

export default component.exports